import { AssetService } from '@shared/api/asset/asset.service';
import { COREZILLA_API_CONFIG } from '@corezilla/api';
import { environment } from '@environment/environment';

export const provideAssetService = () => {
  return [
    {
      provide: COREZILLA_API_CONFIG,
      useValue: environment,
    },
    AssetService,
  ];
};
